import { render, staticRenderFns } from "./InventoryStateConfig.vue?vue&type=template&id=5caf42ba"
import script from "./InventoryStateConfig.vue?vue&type=script&lang=js"
export * from "./InventoryStateConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports